import { Flex } from "@redotech/redo-web/flex";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { PageForm } from "@redotech/redo-web/page-form";
import { Text } from "@redotech/redo-web/text";
import classNames from "classnames";
import { memo } from "react";
import * as teamCss from "../../team.module.css";
import {
  FedexEasyReturnsSettings,
  fedexEasyReturnsDefault,
} from "./fedex-easy-returns-settings";
import { useBlueYonder } from "./use-blue-yonder";

export const FedexEasyReturnsPage = memo(function FedexEasyReturnsPage() {
  const { fedexEasyReturnsSettingsLoad, save, fedexEasyReturnsInput } =
    useBlueYonder();

  if (fedexEasyReturnsSettingsLoad.error) {
    return (
      <Flex>
        <Text textColor="error">{`Something went wrong loading Fedex Easy Returns settings: ${fedexEasyReturnsSettingsLoad.error?.message}`}</Text>
      </Flex>
    );
  }

  if (fedexEasyReturnsSettingsLoad.value === null) {
    return (
      <Flex justify="center" w="full">
        <Text>
          Fedex Easy Returns integration is not enabled for this merchant.
        </Text>
      </Flex>
    );
  }

  return (
    <div className={teamCss.container}>
      <PageForm
        initial={fedexEasyReturnsSettingsLoad.value || fedexEasyReturnsDefault}
        input={fedexEasyReturnsInput}
        save={save}
      >
        <div className={classNames(teamCss.mainForm, gridCss.grid)}>
          <div className={gridCss.span12}>
            <FedexEasyReturnsSettings input={fedexEasyReturnsInput} />
          </div>
        </div>
      </PageForm>
    </div>
  );
});
